<template>
  <div v-show="displayExplanationRef" :class="$style.embroidery_annotation">
    <h3 :class="$style.title">刺繍サービスとは？</h3>
    <div :class="$style.service">
      <p :class="$style.headline">■ どんなサービス？</p>
      <p :class="$style.explanation">
        TENTIALでご購入いただいたBaby系の商品に刺繍を入れることができます。プレゼントやギフトでのご利用がおすすめです。
      </p>
      <p v-for="note of noteList" :key="note" :class="$style.note">{{ note }}</p>
    </div>
    <div :class="$style.img_area">
      <p>完成イメージ(英数字筆記体 / ゴールド)</p>
      <AtomsConsumerImage src="/images/common/cart/embroidery-cursive.png" :class="$style.img" />
    </div>
    <div :class="$style.flow">
      <p :class="$style.headline">■ ご注文方法</p>
      <div v-for="(content, _index) in contents" :key="content.title" :class="$style.contents">
        <p :class="$style.num">{{ _index + 1 }}</p>
        <div :class="$style.head">
          <p>{{ content.title }}</p>
          <p>{{ content.subTitle }}</p>
        </div>
        <AtomsConsumerImage :src="content.img" :class="$style.img" />
      </div>
    </div>
    <AtomsConsumerButton variant="secondary" block @click="emit('close')">閉じる</AtomsConsumerButton>
  </div>
</template>

<script setup lang="ts">
import { EMBROIDERY_UNIT_PRICE } from "~/const/cart"

type Props = {
  displayExplanationRef: boolean
}

type Emit = {
  (e: "close"): void
}

withDefaults(defineProps<Props>(), {
  displayExplanationRef: false,
})

const contents = [
  {
    img: "/images/common/cart/embroidery-contents1.png",
    title: "Baby商品をえらぶ",
    subTitle: "※オフィシャルECサイト限定",
  },
  {
    img: "/images/common/cart/embroidery-contents2.png",
    title: "刺繍するフォント/カラー/テキストを決める",
    subTitle: `（10文字まで税込${EMBROIDERY_UNIT_PRICE}円）`,
  },
  {
    img: "/images/common/cart/embroidery-contents3.png",
    title: "できあがり",
    subTitle: "※混雑状況によりお渡しまでの日数が異なります",
  },
]

const noteList = [
  "※ オフィシャルECサイト以外のECサイト・店舗で購入した商品は承りできません。",
  "※ 通常商品と刺繍サービスの設定をした商品を同時購入する事はできません。",
  "※ eギフトと刺繍サービスを併用で設定する事はできません。",
  "※ 刺繍加工のため、お届けには約14日かかります。",
  "※ 代引き引換での購入はできません。",
  "※ 加工済み商品のキャンセル・返品・交換は原則不可となります。",
  "※ また、混雑状況により、お渡しまでの日数が異なります。詳細はサポートへお問い合わせください。",
]

const emit = defineEmits<Emit>()
</script>

<style module scoped lang="scss">
.embroidery_annotation {
  max-width: $max-width-sm;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  .service {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  .headline {
    font-size: $font-size-16;
    font-weight: bold;
  }
  .note {
    font-size: $font-size-14;
    line-height: 1.8;
    color: $danger;
  }
  .img_area {
    .img {
      width: 100%;
    }
  }
  .flow {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    .contents {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      align-items: center;
      justify-content: center;
      .img {
        width: 75%;
        max-width: 200px;
      }
      .num {
        @include main-font;
        font-size: $font-size-24;
      }
      .head {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        text-align: center;
        p {
          font-size: $font-size-16;
        }
      }
    }
  }
}
</style>
